// extracted by mini-css-extract-plugin
module.exports = {"menu":"_2nwLS6A9IoVx8sa8nTd73s"};